import { api } from './api';
import {
  CrisisCommunicationUser,
  CrisisCommunicationUserCreate,
  CrisisCommunicationUserUpdate,
  CrisisCommunicationUserListResponse,
  CrisisCommunicationAccessCheck,
  CrisisCommunicationBulkImportRequest,
  CrisisCommunicationBulkImportResponse,
  CrisisCommunicationCSVTemplate
} from '../types/crisisCommunicationUser';

export class CrisisCommunicationService {
  private static baseUrl = '/v1/crisis-communication';

  static async checkAccess(): Promise<CrisisCommunicationAccessCheck> {
    const response = await api.get(`${this.baseUrl}/access-check`);
    return response.data;
  }

  static async getUsers(
    page: number = 1,
    perPage: number = 10,
    search?: string
  ): Promise<CrisisCommunicationUserListResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString(),
    });

    if (search) {
      params.append('search', search);
    }

    const response = await api.get(`${this.baseUrl}/users?${params}`);
    return response.data;
  }

  static async getUser(id: number): Promise<CrisisCommunicationUser> {
    const response = await api.get(`${this.baseUrl}/users/${id}`);
    return response.data;
  }

  static async createUser(userData: CrisisCommunicationUserCreate): Promise<CrisisCommunicationUser> {
    const response = await api.post(`${this.baseUrl}/users`, userData);
    return response.data;
  }

  static async updateUser(id: number, userData: CrisisCommunicationUserUpdate): Promise<CrisisCommunicationUser> {
    const response = await api.put(`${this.baseUrl}/users/${id}`, userData);
    return response.data;
  }

  static async deleteUser(id: number): Promise<{ message: string }> {
    const response = await api.delete(`${this.baseUrl}/users/${id}`);
    return response.data;
  }

  static async bulkImportUsers(importRequest: CrisisCommunicationBulkImportRequest): Promise<CrisisCommunicationBulkImportResponse> {
    const response = await api.post(`${this.baseUrl}/bulk-import`, importRequest);
    return response.data;
  }

  static async getCSVTemplate(): Promise<CrisisCommunicationCSVTemplate> {
    const response = await api.get(`${this.baseUrl}/csv-template`);
    return response.data;
  }
}

export const crisisCommunicationService = new CrisisCommunicationService();
